<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @change="change"
      @openEditPage="openEditPage"
      @openEditPageV2="openEditPageV2"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <ChangeCust
      :visible.sync="changeCustOpts.visible"
      :custCode="changeCustOpts.custCode"
      @reload="reload"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import ChangeCust from '../change-cust'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader, ChangeCust },
  mixins: [BaseTable],
  data() {
    return { usePage: true, changeCustOpts: { visible: false, custCode: '' } }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .custInfoListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    change({ custCode }) {
      this.changeCustOpts = { visible: true, custCode }
    },
    openEditPage({ pageType = '', params } = {}) {
      this.$router.push({
        name: 'customerManage-info-edit',
        params: { ...params, pageType },
      })
    },
    openEditPageV2({ pageType, params = {}, query } = {}) {
      this.$router.push({
        name: 'customerManage-info-v2-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
